/**
 * Returns a formatted datetime string for the dateTime attribute.
 * It's possible to have multiple timestamps in the dateTime attribute.
 * This function will return the formatted datetime string.
 *
 * @param {int} timestamp The provided timestamp (of the event).
 * @return {string}
 */
const formattedDatetime = (timestamp) => {
  if( !timestamp ) return;

  const date = new Date( timestamp );
  const year = date.getFullYear();
  const month = String( date.getMonth() + 1 ).padStart( 2, '0' );
  const day = String( date.getDate() ).padStart( 2, '0' );
  const hour = String( date.getHours() ).padStart( 2, '0' );
  const minute = String( date.getMinutes() ).padStart( 2, '0' );
  return `${year}-${month}-${day} ${hour}:${minute}`;
}
export default formattedDatetime;
